<script lang="ts">
    import type DataProvider from '../services/data.provider'
    import type TabsProvider from '../services/tabs.provider'
    import type ServiceProvider from '../services/service.provider'

    export let dataProvider: DataProvider
    export let tabsProvider: TabsProvider
    export let serviceProvider: ServiceProvider

    const onSubmit = (tabKey: string): void => {
        dataProvider.dateRange = tabKey
        serviceProvider.searchService.submitSearch()
    }
</script>

<ul class="bno-tabs__links-holder bno-list--plain" role="tablist" aria-label="Seznam karet">
    {#each tabsProvider.tabOptions as tab, index}
        <li class="bno-tabs__item">
            {#if tab.key === dataProvider.dateRangeParameterFromUrl}
                <button
                    id="link-calendar"
                    class="bno-tabs__link is-active"
                    aria-selected="true"
                    aria-current="tab"
                    role="tab"
                    aria-controls="link-calendar-tab"
                    tabindex="0"
                    on:click={() => onSubmit(tab.key)}
                >
                    {tab.label}
                </button>
            {:else}
                <button
                    id="link-calendar"
                    class="bno-tabs__link"
                    aria-selected="false"
                    role="tab"
                    aria-controls="link-calendar-tab"
                    tabindex="0"
                    on:click={() => onSubmit(tab.key)}
                >
                    {tab.label}
                </button>
            {/if}
        </li>
    {/each}
</ul>